module.exports = __webpack_public_path__ + "img/31.f53fe3b9.jpg";